import { BaseScreen } from "./BaseScreen";

import { NoticeHeaderBlock } from "../blocks/NoticeHeaderBlock";
import { ContinueProductsBlock } from "../blocks/ContinueProductsBlock";
import { NoticeTitleBlock } from "../blocks/NoticeTitleBlock";
import { NoticeLinksBlock } from "../blocks/NoticeLinksBlock";

import type { StateStore } from "../app/state/StateStore";
import type { Screen } from "../app/api/ApiClient";

import type { Block } from "../blocks/Block";

import { CoreHeader } from "./components/CoreHeader";

import type { HeaderEvents } from "./components/HeaderEvents";


type NoticeScreenModel =
    Extract<Screen, { type: "notice" }>;

/**
 * Экран уведомления.
 *
 * Построен по той же архитектуре,
 * что и CoreScreen.
 */
export class NoticeScreen extends BaseScreen {

    private readonly store: StateStore;

    private readonly headerEvents: HeaderEvents;

    private readonly openKrok: (krokId: string) => void;

    private readonly blocks: Block[] = [];

    private root!: HTMLElement;

    constructor(
        _screen: NoticeScreenModel,
        store: StateStore,
        headerEvents: HeaderEvents,
        openKrok: (krokId: string) => void
    ) {

        super();

        this.store = store;
        this.headerEvents = headerEvents;
        this.openKrok = openKrok;

    }

    public override mount(): void {

        super.mount();

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        super.update();

        for (const block of this.blocks) {
            block.unmount();
        }

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public override unmount(): void {

        for (const block of this.blocks) {
            block.unmount();
        }

        this.blocks.length = 0;

        super.unmount();

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =========================
    // BUILD
    // =========================

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        root.className =
            "content";

        const header =
                new CoreHeader(
                    this.headerEvents
                );

            header.mount();

            root.appendChild(
                header.getRoot()
            );
            root.style.paddingTop =
            "70px";    

        this.buildBlocks();

        for (const block of this.blocks) {

            block.mount();

            root.appendChild(
                block.getRoot()
            );

        }

        return root;

    }

    private buildBlocks(): void {

        this.blocks.length = 0;

        this.blocks.push(
            new NoticeHeaderBlock(
                this.store,
                this.openKrok
            )
        );

        this.blocks.push(
            new ContinueProductsBlock(
                this.store,
                this.openKrok
            )
        );

        this.blocks.push(
            new NoticeTitleBlock(
                this.store
            )
        );

        this.blocks.push(
            new NoticeLinksBlock(
                this.store
            )
        );

    }

}